<template>
  <el-dialog
    title="章节训练详情记录"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="90%"
    append-to-body
  >
    <!-- 顶部统计卡片 -->
    <div style="display:flex; justify-content:space-around; background:#f5f7fa; padding:16px; border-radius:4px; margin-bottom:20px;">
      <div style="text-align:center">
        <div style="font-size:22px; font-weight:bold">{{ totalCount }}</div>
        <div style="color:#666">总训练次数</div>
      </div>
      <div style="text-align:center">
        <div style="font-size:22px; font-weight:bold">{{ formatTotalTime(totalTimeMs) }}</div>
        <div style="color:#666">总训练时长</div>
      </div>
      <div style="text-align:center">
        <div style="font-size:22px; font-weight:bold">{{ correctRateFormatted }}%</div>
        <div style="color:#666">平均正确率</div>
      </div>
      <div style="text-align:center">
        <div style="font-size:22px; font-weight:bold">{{ formatTotalTime(avgTimeMs) }}</div>
        <div style="color:#666">平均时长</div>
      </div>
    </div>

    <!-- 表格部分 -->
    <el-table :data="dataList" stripe border :loading="loading">
      <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
      <el-table-column label="评价" align="center">
        <template slot-scope="scope">
          {{ getLevelName(scope.row.level) }}
        </template>
      </el-table-column>
      <el-table-column label="训练时长" align="center">
        <template slot-scope="scope">
          {{ formatTime(scope.row.longthoftime) }}
        </template>
      </el-table-column>
      <el-table-column label="正确率" align="center">
        <template slot-scope="scope">
          {{ formatAccuracy(scope.row.accuracy) }}%
        </template>
      </el-table-column>
      <el-table-column label="训练时间" prop="createtime" align="center" width="180"></el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="queryInfo.pageNo"
      :page-size="queryInfo.pageSize"
      :total="total"
      background
      style="text-align:right; margin-top:20px"
    ></el-pagination>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "ChapterDetailModal",
    props: {
      visible: { type: Boolean, default: false },
      studentId: [String, Number],
      sectionId: [String, Number]
    },
    data() {
      return {
        dialogVisible: false,
        loading: false,
        dataList: [],
        total: 0,
        queryInfo: { pageNo: 1, pageSize: 10 },

        // 改用毫秒存储，前端统一格式化
        totalCount: 0,
        totalTimeMs: 0,
        correctRate: "0",
        avgTimeMs: 0
      };
    },
    computed: {
      // 平均正确率保留两位小数
      correctRateFormatted() {
        const rate = parseFloat(this.correctRate) || 0;
        return rate.toFixed(2);
      }
    },
    watch: {
      visible: {
        handler(val) {
          this.dialogVisible = val;
          if (val) {
            this.queryInfo.pageNo = 1;
            this.loadData();
          }
        },
        immediate: true
      },
      dialogVisible(val) {
        if (!val) this.$emit('update:visible', false);
      }
    },
    methods: {
      // 等级转换军衔
      getLevelName(level) {
        switch (Number(level)) {
          case 8: return '士兵';
          case 7: return '连长';
          case 6: return '营长';
          case 5: return '团长';
          case 4: return '旅长';
          case 3: return '师长';
          case 2: return '军长';
          case 1: return '司令';
          default: return '-';
        }
      },

      // 格式化毫秒为 HH:mm:ss
      formatTime(ms) {
        if (!ms) return '00:00:00';
        let s = parseInt(ms / 1000);
        let h = parseInt(s / 3600).toString().padStart(2, '0');
        let m = parseInt((s % 3600) / 60).toString().padStart(2, '0');
        let sec = (s % 60).toString().padStart(2, '0');
        return `${h}:${m}:${sec}`;
      },

      // 专门格式化总时长（兼容大数）
      formatTotalTime(ms) {
        if (!ms || ms <= 0) return '00:00:00';
        let s = parseInt(ms / 1000);
        let h = Math.floor(s / 3600).toString().padStart(2, '0');
        let m = Math.floor((s % 3600) / 60).toString().padStart(2, '0');
        let sec = (s % 60).toString().padStart(2, '0');
        return `${h}:${m}:${sec}`;
      },

      // 格式化表格内的正确率，保留两位小数
      formatAccuracy(accuracy) {
        const acc = parseFloat(accuracy) || 0;
        return acc.toFixed(2);
      },

      async loadData() {
        this.loading = true;
        try {
          let params = {
            studentId: this.studentId,
            textbookSectionId: this.sectionId,
            pageNo: this.queryInfo.pageNo,
            pageSize: this.queryInfo.pageSize
          };

          const { data: res } = await this.$http.post(
            "/ea/student/student/vipssStudentCapterStatisticsDetail",
            params
          );

          if (res.code !== 200) {
            this.$message.error(res.message);
            return;
          }

          this.dataList = res.result.records || [];
          this.total = res.result.total || 0;

          if (this.dataList.length > 0) {
            let first = this.dataList[0];
            this.totalCount = first.totalCount || 0;
            // 关键修复：后端返回的是字符串类型的毫秒数，转成数字
            this.totalTimeMs = parseInt(first.totalTimeStr) || 0;
            this.correctRate = first.correctRate || "0";
            this.avgTimeMs = parseInt(first.avgTimeStr) || 0;
          } else {
            this.totalCount = 0;
            this.totalTimeMs = 0;
            this.correctRate = "0";
            this.avgTimeMs = 0;
          }

        } catch (err) {
          this.$message.error("请求失败");
        } finally {
          this.loading = false;
        }
      },

      handleCurrentChange(page) {
        this.queryInfo.pageNo = page;
        this.loadData();
      },

      closeDialog() {
        this.dialogVisible = false;
      }
    }
  };
</script>
